<h3 class="text-lg font-semibold text-neutral-900 mb-xl">{{ 'custom_workflow_preview_title' | transloco }}</h3>
@if (groups(); as g) {
  <lib-form-builder [group]="g" [form]="form" />
} @else {
  <div class="flex justify-center py-2xl"><lib-loader /></div>
}
